import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {UsersListComponent} from './users-list/users-list.component';
import {UserFormComponent} from './user-form/user-form.component';
import {UsersLayoutComponent} from './users-layout/users-layout.component';
import {UsersRolesResolverService} from '@providers/_resolvers/users-roles-resolver.service';
import {UsersResolver} from './services/users.resolver';
import {UserRoleFormComponent} from './user-role-form/user-role-form.component';
import {CheckPermissionsGuardService} from '@services/guards/check-permissions.guard.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {RoutesStorage} from '@helpers/routes.helper';
import {NotForCurrentUserGuardService} from './services/not-for-current-user.guard.service';


export const usersRoutes: Routes = [
    {
        path: '',
        component: UsersLayoutComponent,
        canActivate: [CheckPermissionsGuardService],
        data: {
            permissions: [
                UserNamespace.Permission.organizationUserView,
            ],
            fallbackUrl: RoutesStorage.Organization.edit
        },
        children: [
            {
                path: '',
                component: UsersListComponent,
                data: {
                    title: 'Пользователи'
                },
                resolve: {
                    users: UsersResolver,
                }
            },
            {
                path: '',
                resolve: {
                    roles: UsersRolesResolverService,
                },
                children: [
                    {
                        path: 'invite',
                        component: UserFormComponent,
                        canActivate: [CheckPermissionsGuardService],
                        data: {
                            title: 'Пригласить пользователя',
                            permissions: [
                                UserNamespace.Permission.organizationUserCreate,
                            ],
                            fallbackUrl: RoutesStorage.Organization.usersList
                        },
                    },
                    {
                        path: ':id/role-edit',
                        component: UserRoleFormComponent,
                        canActivate: [
                            CheckPermissionsGuardService,
                            NotForCurrentUserGuardService,
                        ],
                        data: {
                            title: 'Редактирование роли пользователя',
                            resolveAsForm: true,
                            permissions: [
                                UserNamespace.Permission.organizationUserChangeRole,
                            ],
                            fallbackUrl: RoutesStorage.Organization.usersList
                        },
                        resolve: {
                            user: UsersResolver,
                        }
                    },
                ],
            },
        ],
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(usersRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class UsersRoutingModule {}
